import { useQuery } from "@tanstack/react-query";
import { getApiActionHistory } from "Infrastructure/Api/Api";

export const ACTION_HISTORY_QUERY_KEY = "ACTION_HISTORY_QUERY";

export function useGetActionHistoryQuery(offset: number, limit: number, types: string, device?: string, requestId?: string) {
  return useQuery({
    queryKey: [ACTION_HISTORY_QUERY_KEY, offset, limit, types, device, requestId],
    queryFn: () => getApiActionHistory(offset, limit, types, device, requestId),
  });
} 